module.exports = __webpack_public_path__ + "img/vertical_6_7_9006.b51cd916.png";